import React from 'react';
import { Button, Modal } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';
import { useDeferredClose } from 'packages/hooks/useDeferredClose';

const AccessNotificationModal = ({ title, description, loading, isOpen, toggleOpen }) => {
    const [shouldRender, onCloseAnimationEnd] = useDeferredClose(isOpen);
    const { translate } = useTranslate();

    if (!shouldRender) {
        return null;
    }

    return (
        <Modal
            container={modalContainer}
            title={title}
            isOpen={isOpen}
            onCloseAnimationEnd={onCloseAnimationEnd}
            onClose={toggleOpen}
            actionPrimary={
                <Button
                    variant="primary"
                    onClick={toggleOpen}
                    isDisabled={loading}
                    isLoading={loading}
                    data-testid="ok-button"
                >
                    {translate('modal.design.access.button')}
                </Button>
            }
        >
            {description}
        </Modal>
    );
};

export default React.memo(AccessNotificationModal);
